import Grid from "@mui/material/Grid";
import MySelect from "../../components/MySelect";

const FacilitiesFilter = ({options, filter, filterChangeFunctions}) => {
    return (
        <Grid container spacing={1}>
            <Grid item xs={12}>
                <MySelect
                    label="Business Unit"
                    options={options}
                    value={filter.businessUnitCode}
                    autoSelect={true}
                    onChange={(value) => filterChangeFunctions.businessUnitCode(value)}
                />
            </Grid>
        </Grid>
    );
};

export default FacilitiesFilter;
